export const MARKET_ID_PARAM = 'marketId';
